import { byteToUnit, getCurrentImage } from "../../../utils/GeneralUtils";
import {
  getErrorMessage,
  valFile,
  ValType,
} from "../../../utils/ValidationFunctions";
import styles from "./ImageTool.module.scss";

export default class ImageTool {
  public data;
  public api;
  public config: { save: () => void };
  public error: boolean = false;
  public input: HTMLInputElement;
  static get toolbox() {
    return {
      title: "Image",
      icon: '<i class="fas fa-image" style=height:12px></i>',
    };
  }

  constructor({ data, api, config }: any) {
    this.data = data;
    this.api = api;
    this.config = config;
    this.input = document.createElement("input");
  }

  render() {
    const wrapper = document.createElement("div");
    wrapper.classList.add("cdx-block");
    wrapper.classList.add(styles["simple-image-wrapper"]);

    const label = document.createElement("label");
    label.innerText = "ファイルを選択（10MB以内）";
    const img = document.createElement("img");

    // error message field
    const message = document.createElement("div");
    message.classList.add(styles["simple-image-message"]);

    // input
    this.input.setAttribute("type", "file");

    this.input.addEventListener("change", () => {
      if (this.input.files?.[0]) {
        if (!valFile(this.input.files[0])) {
          img.setAttribute("src", "");
          message.classList.add(styles["error"]);
          message.innerText = getErrorMessage(ValType.File);

          // 以前保存したデータを削除
          this.data = {};
          return;
        }

        message.classList.remove(styles["error"]);
        message.innerText = `${this.input.files[0].name} (${byteToUnit(
          this.input.files[0].size,
          "KB"
        )})`;
        img.setAttribute("src", getCurrentImage(this.input.files[0]));
        this.config.save();
        return;
      }
    });
    if (this.data instanceof File) {
      img.setAttribute("src", getCurrentImage(this.data));
      message.innerText = `${this.data.name} (${byteToUnit(
        this.data.size,
        "KB"
      )})`;
    } else if (this.data.id !== 0 && this.data.large?.url) {
      img.setAttribute("src", this.data.large.url);
    } else {
      img.setAttribute("src", "");
    }

    //
    wrapper.appendChild(label);
    label.appendChild(this.input);
    wrapper.appendChild(img);
    wrapper.appendChild(message);
    return wrapper;
  }

  validate(saveData: any) {
    // 空データでなければ保存
    if (saveData) {
      this.data = saveData;
      return true;
    } else {
      return false;
    }
  }

  // 返した値がvalidateに渡される
  save() {
    // 画像が選択されている場合
    if (this.input.files?.[0] instanceof File) {
      return this.input.files?.[0];
    }

    // 以前保存した画像がある場合
    if (typeof this.data === "object" && Object.keys(this.data).length) {
      return this.data;
    }

    // this.dataがファイルデータの場合
    if (this.data instanceof File) {
      return this.data;
    }

    return undefined;
  }

  destroy() {
    this.data = null;
  }
}
